import { IStorageService } from "../../platform/services/storage/StorageService";
import { getExtensionFromMimeType } from "./getExtensionFromMimeType";
import { nanoid } from "nanoid";
import { compressImage } from "./compressImage";

export interface TaskImageUploadResult {
    path: string,
    thumbPath: string,
}

export interface UploadCallbacks {
    completeCallback?: () => void;
    progressCallback?: (progress: { loaded: number; total: number }) => void;
    errorCallback?: (err: Error) => void;
}

export const uploadTaskReportImage = async (
    file: File, 
    unitId: string, 
    taskId: string, 
    storageService: IStorageService,
    tenantId: string,
    callbacks?: UploadCallbacks
): Promise<TaskImageUploadResult> => {
    const mimeType = file.type;
    const extension = getExtensionFromMimeType(mimeType);
    const base = `tr/${unitId}/${taskId}/${nanoid(6)}`;

    let thumbBlob = await compressImage(file, 100, 108, 108);

    const blob = await compressImage(file, 80);
    if (!blob) {
        throw new Error('compression failed');
    }

    if (!thumbBlob) {
        throw new Error('compression failed');
    }

    try {
        const uploadResult = await storageService.upload(
            new File([blob], `${base}.${extension}`, { type: 'image/jpeg' }),
            `${base}.${extension}`,
            { contentType: 'image/jpeg', tenantId }
        );
        
        const uploadThumbResult = await storageService.upload(
            new File([thumbBlob], `${base}.thumb.${extension}`, { type: 'image/jpeg' }),
            `${base}.thumb.${extension}`,
            { contentType: 'image/jpeg', tenantId }
        );

        if (callbacks?.completeCallback) {
            callbacks.completeCallback();
        }

        return {
            path: uploadResult.path.replace(`${tenantId}/`, ''), // Remove tenant prefix for backward compatibility
            thumbPath: uploadThumbResult.path.replace(`${tenantId}/`, ''), // Remove tenant prefix for backward compatibility
        };
    } catch (error) {
        if (callbacks?.errorCallback) {
            callbacks.errorCallback(error as Error);
        }
        throw error;
    }
};
